import {RouterReducerState, getRouterSelectors} from '@ngrx/router-store';
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {HistoryState, getNavHistory, historyFeatureKey} from './router.reducer';

export const selectRouter = createFeatureSelector<RouterReducerState>('router');
export const {
  selectCurrentRoute,
  selectFragment,
  selectQueryParams,
  selectQueryParam,
  selectRouteParams,
  selectRouteParam,
  selectRouteData,
  selectUrl,
} = getRouterSelectors(selectRouter);

export const selectSelectedProductId = selectRouteParam('productId');
export const selectSelectedOrganizationId = selectRouteParam('currentOrgId');

export const selectHistoryState = createFeatureSelector<HistoryState>(historyFeatureKey);
export const selectHistory = createSelector(selectHistoryState, getNavHistory);
